"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var AbstractValueAccessor_1 = require("@utils/AbstractValueAccessor");
var TypeaheadComponent = /** @class */ (function (_super) {
    __extends(TypeaheadComponent, _super);
    function TypeaheadComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.queryParams = {};
        _this.multiple = false;
        _this.addTag = false;
        _this.name = '';
        _this.placeholder = '';
        _this.update = new core_1.EventEmitter();
        return _this;
    }
    return TypeaheadComponent;
}(AbstractValueAccessor_1.AbstractValueAccessor));
exports.TypeaheadComponent = TypeaheadComponent;
